import { useNavigate } from "react-router-dom";
import { ErrorState } from "@leagueplatform/web-common-components";
import { Box, queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import ERROR from "assets/not-found.svg";
import { CenteredLayout } from "components/centered-layout/centered-layout.component";

export const PageNotFound = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));

  return (
    <CenteredLayout>
      <Box css={{ padding: isMobile ? "$oneAndHalf" : "$twoAndHalf" }}>
        <ErrorState
          headingString={formatMessage({ id: "STR_SORRY_WE_CANT_FIND_PAGE" })}
          error={null}
          onButtonClick={() => navigate(APP_MANAGED_ROUTES.HOME)}
          buttonText={formatMessage({ id: "STR_GO_TO_HOME" })}
          imageSrc={ERROR}
          css={{
            marginBlockStart: "$one",
            ".error-state-button-wrapper": {
              display: "block",
            },
            ".error-state-button": {
              width: 328,
              maxWidth: "100%",
              justifyContent: "center",
            },
            ".error-state-heading-text": {
              width: 328,
            },
          }}
        />
      </Box>
    </CenteredLayout>
  );
};
